/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import type { LexicalEditor } from 'lexical';
  

import {useEffect } from 'react';
import { $Tree, TreePM, useTreePs } from './useTreePs';
  
type TreeProps = {
    editor: LexicalEditor;
    timeTravelButtonClassName: string;
    timeTravelPanelButtonClassName: string;
    timeTravelPanelClassName: string;
    timeTravelPanelSliderClassName: string;
    viewClassName: string;
  }

  
  export const  TreeView = (props : TreeProps ): JSX.Element  => {

    const {
      timeTravelButtonClassName,
      timeTravelPanelSliderClassName,
      timeTravelPanelButtonClassName,
      viewClassName,
      timeTravelPanelClassName,
      editor,
    } = props


    const {$, pm}:{$:$Tree, pm:TreePM} = useTreePs()
    
    const {timeStampedEditorStates, content, timeTravelEnabled, isPlaying} = pm

    

    useEffect(() => {
      return $.tree.watchContent(editor)
    }, [timeTravelEnabled, editor, $]);
  
    useEffect(() => {
      if (pm.isPlaying) {
        return $.timetravel.playback()
      }
    }, [pm, $]); 
  
    useEffect(() => {
      return $.tree.wft(editor)
    }, [editor, $]);

  
    const totalEditorStates = timeStampedEditorStates.length;

    return (
      <div className={viewClassName}>
        {!timeTravelEnabled && totalEditorStates > 2 && (
          <button className={timeTravelButtonClassName}
            onClick={$.timetravel.start}>
            Time Travel
          </button>
        )}
        {pm.form && TreeForm(pm.form)}
        <pre ref={$.ref.treeElement}>{content}</pre>

        {timeTravelEnabled && (
          <div className={timeTravelPanelClassName}>
            <button className={timeTravelPanelButtonClassName}
              onClick={$.toggleIsPlaying}>
              {isPlaying ? 'Pause' : 'Play'}
            </button>
            <input className={timeTravelPanelSliderClassName}
              ref={$.ref.input}
              onChange={$.timetravel.transport}
              type="range"
              min="1"
              max={totalEditorStates - 1}
            />
            <button
              className={timeTravelPanelButtonClassName}
              onClick={$.timetravel.exit }>
              Exit
            </button>
          </div>
        )}
      </div>
    );
  }
 
  
const TreeForm = (form) => {


  return (<div>
    {form.fields.map( field => (
      <div key={field}>
        {field}' = "'' {form.values[field]}'"'
        </div>))}

      
  </div>)
}